import { ProviderSettingsItem } from '@backstage/plugin-user-settings';
import Star from '@material-ui/icons/Star';
import { devhubAuthApiRef, devHubGhecAuthApiRef } from '../../../apis';
import { ConfigFeatureCheck } from '../../util/ConfigFeatureCheck';
import { Feature } from '@devxdiscover/devhub-common';

/**
 * The authentication providers to render on the settings page.
 */
export const authProviders = (
  <>
    <ConfigFeatureCheck feature={Feature.GITHUB_ENTERPRISE_CLOUD}>
      <ProviderSettingsItem
        title="GitHub Enterprise Cloud"
        description="Provides authentication for GHEC APIs"
        apiRef={devHubGhecAuthApiRef}
        icon={Star}
      />
    </ConfigFeatureCheck>
    <ProviderSettingsItem
      title="DevHub"
      description="DevHub Authentication"
      apiRef={devhubAuthApiRef}
      icon={Star}
    />
  </>
);
